import { default as category } from './category/routes'
import { default as status } from './status/routes'
import { default as group } from './group/routes'

export default [
    ...category,
    ...status,
    ...group
]